"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageButtons = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var ui_text_1 = require("@hopin-team/ui-text");

var react_1 = tslib_1.__importStar(require("react"));

var context_1 = require("../context");

var generate_truncated_pages_1 = require("../lib/generate-truncated-pages");

var list_1 = require("../styled/list");

var page_button_1 = require("./page-button");

var PageButtons = function PageButtons(_a) {
  var className = _a.className,
      __UIScope = _a.__UIScope,
      _b = _a.truncateAt,
      truncateAt = _b === void 0 ? 5 : _b;
  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'Pagination-PageButtonGroup',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;

  var _c = (0, react_1.useContext)(context_1.PaginationContext),
      currentPage = _c.currentPage,
      totalPages = _c.totalPages;

  if (!totalPages) {
    return react_1.default.createElement("div", null);
  }

  var _d = (0, generate_truncated_pages_1.generateTruncatedPages)({
    truncateAt: truncateAt,
    currentPage: currentPage,
    totalPages: totalPages
  }),
      indices = _d.indices,
      withLeadingEllip = _d.withLeadingEllip,
      withTrailingEllip = _d.withTrailingEllip;

  return react_1.default.createElement(list_1.List, {
    className: rootClasses
  }, react_1.default.createElement("li", null, react_1.default.createElement(page_button_1.PageButton, {
    index: 1,
    mr: 0.5
  })), withLeadingEllip && react_1.default.createElement(ui_text_1.Text, {
    color: "grey-500",
    mx: 0.5
  }, "\u2026"), indices.map(function (index) {
    return react_1.default.createElement("li", {
      key: index
    }, react_1.default.createElement(page_button_1.PageButton, {
      index: index,
      mx: 0.5
    }));
  }), withTrailingEllip && react_1.default.createElement(ui_text_1.Text, {
    color: "grey-500",
    mx: 0.5
  }, "\u2026"), totalPages > 1 && react_1.default.createElement("li", null, react_1.default.createElement(page_button_1.PageButton, {
    index: totalPages,
    ml: 0.5
  })));
};

var PageButtonsWithSpace = (0, ui_helper_with_space_1.withSpace)(PageButtons);
exports.PageButtons = PageButtonsWithSpace;